import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import '../../App.css'
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrencyDispatch } from '../../reducers/HomeReducer';
import { setSelectedCurr } from '../../reducers/UiReducer';

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
  formControl: {
    // margin: theme.spacing(1),
    minWidth: 120
    
  },
  root:{
    '& .MuiMenu-paper':{
      maxHeight:200
    }
  }
}));
const ISOCode =[{
    img:'inr',
    code:'INR'
},{
  img:'usd',
  code:'USD'
},{
  img:'afn',
  code:'AFN'
},
{
  img:'all',
  code:'ALL'
},
]
// {
//   img:'amd',
//   code:'AMD'
// },
// {
//   img:'ang',
//   code:'ANG'
// },
// {
//   img:'aoa',
//   code:'AOA'
// },
// {
//   img:'ars',
//   code:'ARS'
// },
// {
//   img:'aud',
//   code:'AUD'
// },
// ,
// {
//   img:'awg',
//   code:'AWG'
// },
// ,
// {
//   img:'azn',
//   code:'AZN'
// },
// ,
// {
//   img:'bam',
//   code:'BAM'
// },
// ,
// {
//   img:'bbd',
//   code:'BBD'
// },
// ,
// {
//   img:'bdt',
//   code:'BDT'
// }
export default function Currency() {
  const classes = useStyles();
  const {curr} = useSelector((state)=>state.ui)
  const [age, setAge] = React.useState(curr);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  
  const handleChange = (event) => {
    setAge(event.target.value);
    // dispatch(fetchCurrencyDispatch(event.target.value))
    dispatch(setSelectedCurr(event.target.value))
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
 

  return (
    <div className={classes.root} style={{marginLeft:20}}>
      {/* <Button className={classes.button} onClick={handleOpen}>
        Open the select
      </Button> */}
      <FormControl className={classes.formControl}>
        <InputLabel id="demo-controlled-open-select-label">Currency</InputLabel>
        <Select
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={age}
          onChange={handleChange}
          style={{maxHeight:250}}
        >
          {ISOCode.map((item,index)=>{
            return  <MenuItem value={item.code}><img src={`https://mb.musafirbazar.com/img/flags/${item.img}.png`} style={{marginRight:10,height:20,width:20}}/>{item.code}</MenuItem>
          })}
          
        </Select>
      </FormControl>
    </div>
  );
}
